import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { AuthService } from '@services/auth.service';
import { FswService } from '@services/fsw.service';
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-add-testingcapability',
  templateUrl: './add-testingcapability.component.html',
  styleUrls: ['./add-testingcapability.component.scss']
})
export class AddTestingcapabilityComponent implements OnInit {

  testingData: { testId: any; createdBy: string } | undefined;
  p: number = 1;
  itemsPerPage: number = 10;
  private apiURL = environment.apiURL;

  @ViewChild('myInput')
  myInputVariable!: ElementRef;

  constructor(private router: Router, private fswService: FswService, private authService: AuthService, private spinnerService: NgxSpinnerService, private toastr: ToastrService, private route: ActivatedRoute) { }
  products!: any[];

  selectedproductId!: Number;

  selectedProdctName!: any;

  submitted: boolean = false;
  testingRecordData!: any[];
  isReadMode = true;
  role: any;
  userRecordData: any[] | undefined;
  selectedvehicle: any = null;
  userId : any;

  ngOnInit(): void {
    debugger
    this.role = this.authService.getRole();
    this.bindProduct();
    this.getUserData();
    
    this.route.params.subscribe(params => {
      debugger
      this.userId = params['userId']; // (+) converts string 'id' to a number
      this.selectedvehicle = this.userId;
    });
    this.bindtestingcapabilitylist(this.userId);
    this.selectedproductId = null;
  }

  data!: [];
  parameters: any[];
  addParameters: any[] = [];
  param: any = { name: "", value: "", result: "" };
  success: boolean = false;
  nonresult: boolean = false;
  fileFlag: boolean = false;

  //
  bindtestingcapabilitylist(userId) {
    debugger
    this.spinnerService.show();
    this.fswService.gettestingcapabilitylist(userId).subscribe((data: any[]) => {
      this.testingRecordData = data;
      this.spinnerService.hide();
    })
  }
  //

  bindProduct() {
    this.spinnerService.show();
    this.fswService.getProducts().subscribe((data: any[]) => {
      this.products = data;
      this.spinnerService.hide();
    })

  }
  productChanged() {
    this.products = [];
    this.bindParameter()


  }
  bindParameter() {
    this.spinnerService.show();
    this.fswService.getFSWParameters(this.selectedvehicle, this.selectedproductId).subscribe((data: any[]) => {
      this.parameters = data;
      this.selectedProdctName = data[0].productName;
      this.spinnerService.hide();
    })

  }
  updateInsertData() {
    debugger;
    this.nonresult = false;
    this.submitted = true;
    var sampleId = 0;
    let testingData: any = [];
    this.parameters.forEach(item => {
     testingData.push({ id: item.Id, mappingId: item.mappingId, vehicleNo: this.selectedvehicle, createdBy: this.authService.getUserName(), result: item.result })
    })
    this.fswService.saveFSWTestCapability(testingData)
    .subscribe(
      resp => {
        debugger
        console.log(resp)
        this.submitted = true;
        this.spinnerService.hide();
        this.toastr.success('Test Capability Added Successfully!');
        this.bindProduct();
        this.isReadMode = true;
      },
      error => {
        debugger
        console.log(error);
        this.toastr.error('Some Error Occured!');
        this.spinnerService.hide();
      });
  }

updateRow(x: any) {
    debugger
    var delBtn = confirm(" Do you want to update ?");
    if (delBtn == true) {
      debugger
      if (x) {
        this.spinnerService.show();
        this.isReadMode = false;
        this.spinnerService.hide();
      }
      else {
        this.isReadMode = false;
      }
    }
  }
  createRow() {
    this.isReadMode = false;
    this.bindProduct();
  }
  getUserData() {
    debugger
    this.spinnerService.show();
    this.fswService.getVehicleListByState(this.authService.getState()).subscribe((data: any[]) => {
      debugger
      this.userRecordData = data;
      this.spinnerService.hide();
    })
  }
  backOption() {
  window.history.back();
  }
  showisReadMode()
    {
      this.isReadMode = true;
    }


}
